import React, { useState } from 'react';
import Calendar from 'react-calendar';
import '../css/BookingCalendar.css';

export default function BookingCalendar( props ) {

  const [ value, onChange ] = useState( new Date() )

  //console.log( 'BookingCalendar', props )
  //return false

  let start = new Date()
  let end = new Date()

  if ( props.start && props.end ) {
    start = new Date( props.start )
    end = new Date( props.end )
  } 

  function getDates( value ) {
  	onChange( value )
  }

  function styleDate({ activeStartDate, date, view }) {
  	if ( view !== 'month' ) return null
    date.setMinutes(date.getMinutes() - date.getTimezoneOffset())
    if ( date.getTime() === start.getTime() ) return 'react-calendar-highlight-first'
    if ( date.getTime() === end.getTime() ) return 'react-calendar-highlight-last'
    if ( date.getTime() > start.getTime() && date.getTime() < end.getTime() ) return 'react-calendar-highlight'
    return null
  }

  return (
      <Calendar 
      	onChange={ false && getDates } 
      	value={ value } 
      	
      	//allowPartialRange={ true }
      	//selectRange={ true }
      	minDate={ new Date() }

      	prev2Label={ null }
      	next2Label={ null }
      	
      	prevLabel={ null }
      	nextLabel={ null }

      	minDetail="month"

      	//onClickDay={ e => e.preventDefault() }
      	//onClickDay={ e => onChange( null ) }

      	activeStartDate={ start }
      	//tileContent={ ({ activeStartDate, date, view }) => view === 'month' && date.getDay() === 3 ? <>S</> : null }
      	tileClassName={ styleDate }

      	//tileClassName={ ({ activeStartDate, date, view }) => view === 'month' && date >= new Date( 2025, 4, 18 ) && date <= new Date( 2025, 4, 25 ) ? 'react-calendar-highlight' : null }

      	//tileDisabled={ ({ activeStartDate, date, view }) => date.getDay() === 0 }

  	/>
  )

}
